import StringComponent from './String';
export default StringComponent;
